import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { useBoards } from '../data';
import LoadingComponent from '../../../shared/LoadingComponent/LoadingComponent.jsx';
import useDropdown from '../../../lib/hooks/useDropdown';
import Boards from './Boards.jsx';
import CreateBoardButton from './CreateBoardButton.jsx';
import {
  SITE_ADMIN,
  RESTRICTED_SITE_ADMIN,
} from '../../../lib/utils/constants/UserTypes';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

export default function BoardSelect({ userType }) {
  const currentBoardName = useSelector(state => state.currentBoard.name);

  const { boards, isLoading, isIdle, fetchBoards } = useBoards();
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();

  const onDropdownClick = () => {
    if (isIdle) {
      fetchBoards();
    }
    setShowDropdown(show => !show);
  };

  return (
    <Wrapper>
      <CurrentBoard
        id="currentBoard"
        color="black.100"
        onClick={onDropdownClick}
        ref={buttonRef}
      >
        {currentBoardName}
        <DropdownIcon showingdropdown={showDropdown.toString()} />
      </CurrentBoard>
      <Dropdown
        id="boardDropdown"
        ref={dropdownRef}
        bg="white"
        showDropdown={showDropdown}
      >
        {[SITE_ADMIN, RESTRICTED_SITE_ADMIN].includes(userType) && (
          <CreateBoardButton />
        )}
        {isLoading ? (
          <LoadingComponent marginBottom="20px" />
        ) : (
          <Boards boards={boards} />
        )}
      </Dropdown>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: none;

  ${themeGet('mediaQueries.forMediumUp')} {
    margin: 0 0 0 24px;
    position: relative;
    display: block;
  }
`;

const DropdownIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-solid fa-chevron-down fa-2xs',
  }),
)`
  transition: all 0.7s ease-out;
  margin: 0 0 0 4px;

  ${props => props.showingdropdown === 'true' && 'transform: rotateX(180deg);'}
`;

const CurrentBoard = styled.div`
  color: ${themeGet('colors.black.80')};
  font-weight: 500;
  font-size: 18px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Dropdown = styled.div`
  ${color}
  border-radius: 8px;
  width: 520px;
  position: absolute;
  box-shadow: 0px 4px 8px rgba(37, 40, 43, 0.24);
  margin: 14px 0 0;
  display: ${({ showDropdown }) => (showDropdown ? 'flex' : 'none')};
  flex-direction: column;
  z-index: 999;
`;
